import { Asset } from "@hermes/api-model-asset";
import {
    ProductBuckleVariant,
    ProductColorVariant,
    ProductFinishVariant,
    ProductLeatherVariant,
    ProductSizeVariant,
    ProductStrapVariant,
    ProductVolumeVariant,
    CrossSellingProduct,
    ProductVariants,
} from "@hermes/api-model-product";

export const BUCKLE = "buckle";
export const LEATHER = "leather";
export const SIZE = "size";
export const COLOR = "color";
export const VOLUME = "volume";
export const STRAP = "strap";
export const FINISH = "finish";
export const STRAP_SIZE = "strapSize";

export type ProductVariantType =
    | typeof BUCKLE
    | typeof LEATHER
    | typeof SIZE
    | typeof COLOR
    | typeof VOLUME
    | typeof STRAP
    | typeof FINISH
    | typeof STRAP_SIZE;

export interface CrossSell {
    keepExploring: {
        total: number;
        items: CrossSellingProduct[];
    };
    perfectPartner: {
        total: number;
        items: CrossSellingProduct[];
    };
}

export interface VariantExpandedState {
    color: boolean;
    volume: boolean;
    buckle: boolean;
    leather: boolean;
    size: boolean;
    strap: boolean;
    finish: boolean;
    strapSize: boolean;
    [key: string]: boolean;
}

export interface ZoomModalState {
    zoomStatus: boolean;
    currentIndex?: number;
    zoomAssets?: Asset[];
    isTopLevelProduct?: boolean;
    currentAssetUrl?: string;
}

export interface SelectedVariantVariantsState {
    color?: ProductColorVariant;
    volume?: ProductVolumeVariant;
    buckle?: ProductBuckleVariant;
    leather?: ProductLeatherVariant;
    size?: ProductSizeVariant;
    strap?: ProductStrapVariant;
    finish?: ProductFinishVariant;
    strapSize?: ProductSizeVariant;
}

export interface LazyLoadedProduct {
    /**
     * Index of product on cross selling grid.
     */
    index: number;
    /**
     * Product displayed datas
     */
    product: CrossSellingProduct;
}

/** Types needed by selector top layer */

export type PluralVariantName = Extract<
    keyof ProductVariants,
    "buckles" | "leathers" | "sizes"
>;
